<div class="content">
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-icon class="card-header-icon" mat-card-avatar>account_circle</mat-icon>
            <mat-card-title>Organizations</mat-card-title>
            <mat-card-subtitle>List of all organizations</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
            <button style="margin-left: 10px;" mat-flat-button color="primary">NEW ORGANIZATION</button>
        </mat-card-actions>
        <mat-card-content>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="organizationId">
                    <th mat-header-cell *matHeaderCellDef> Id </th>
                    <td mat-cell *matCellDef="let organization"> {{organization.organizationId}} </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let organization"> {{organization.name}} </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let organization">
                        <button mat-icon-button>
                            <mat-icon class="icon" title="Edit Organization">edit</mat-icon>
                        </button>
                        <button mat-icon-button>
                            <mat-icon class="icon red-icon" title="Delete Organization">delete_forever</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>